import type { UserAttributes } from '@optimizely/optimizely-sdk'
import { useDecision } from '@optimizely/react-sdk'
import * as React from 'react'

export function useDecisionWhenReady({
  key,
  timeout = 2000,
  overrideAttributes = {},
}: {
  key: string
  timeout?: number
  overrideAttributes?: UserAttributes
}): { isReady: boolean, enabled: boolean } {
  const [decisionEnabled, setDecisionEnabled] = React.useState<boolean>(false)
  const [isReady, setIsReady] = React.useState<boolean>(false)

  const options = React.useMemo(() => ({ timeout }), [timeout])
  const userContext = React.useMemo(() => ({ overrideAttributes }), [overrideAttributes])

  const [decision, clientReady, didTimeout] = useDecision(key, options, userContext)

  React.useEffect(() => {
    if (clientReady && !didTimeout) {
      setDecisionEnabled(decision.enabled)
      setIsReady(true)
    }
    else if (didTimeout && !clientReady) {
      setDecisionEnabled(false)
      setIsReady(true)
    }
  }, [clientReady, didTimeout, decision])

  return {
    isReady,
    enabled: decisionEnabled,
  }
}
